import { TAO_KOE, Render, DynamicYieldAPI } from './../libs';

class SearchInitialProductSuggestions {
	rendered = false;

	constructor( containerEl ) {
		this.containerEl = containerEl;
		this.searchEl = this.containerEl.closest( '.mdl_search' );

		// Add Events.
		[ 'click', 'touchstart', 'mouseenter', 'focusin', 'open_searchbox.sl' ].forEach( ( eventName ) => {
			this.searchEl.addEventListener( eventName, () => this.render(), { once: true, passive: true } );
		} );
	}
	async getData() {
		const selector = this.containerEl.dataset.selector || 'API_Widget_CMS_Search_Initial_Suggestions';

		// Fetch the data and cache in SessionStorage.
		const choice = await DynamicYieldAPI.getChoices( selector, {
			'context': window.DY.recommendationContext,
			'options': {
				'recsProductData': {
					'fieldFilter': [
						'name',
						'brand',
						'url',
						'image_url',
					],
				},
			},
		} ).then( ( { choices } ) => {
			return choices[ selector ];
		} );
		return choice;
	}

	async render() {
		// Render the products.
		if ( this.rendered ) {
			return;
		}
		this.rendered = true;

		return await this.getData().then( ( { variations } ) => {
			const { type, data } = variations[ 0 ].payload; // eslint-disable-line no-unused-vars
			const { custom, slots } = data; // eslint-disable-line no-unused-vars

			return slots.map( ( { sku, slotId, index, productData } ) => ( {
				sku,
				slotId,
				index,
				'brand': productData.brand,
				'name': productData.name,
				'ImageURL': productData.image_url.replace( '768_1024_75', '192_256_75' ),
				'Deeplink': productData.relative_url,
			} ) );
		} ).then( ( suggestions ) => {
			Render.render( 'factfinderSuggestProduct', { productCols: 3, suggestions, mark: ( input ) => input } ).then( ( html ) => {
				const fragment = document.createRange().createContextualFragment( html );
				const productEls = Array.from( fragment.querySelectorAll( '.mdl_search__suggestions-product' ) );
				this.containerEl.replaceChildren( ...productEls );
			} );
		} );
	}
}

TAO_KOE.ready( 'search-initial-product-suggestions.js', function() {
	const SearchProductSuggestionEl = document.querySelector( '.mdl_search__initial .mdl_search__suggestions-products' );
	if ( SearchProductSuggestionEl ) {
		SearchProductSuggestionEl.KOE_SEARCH_INITIALPRODUCT_SUGGESTIONS ??= new SearchInitialProductSuggestions( SearchProductSuggestionEl );
	}
} );
